module.exports = __webpack_public_path__ + "static/media/banner1.eef03bb7.jpg";